@import '../../styles/palette.scss';

.emptyStateContainer {
  padding: 6.25rem 0.625rem 0.625rem;
  text-align: center;

  h3 {
    color: _palette(secondary);
    font-size: 1.3rem;
    font-weight: bold;
    margin-bottom: 0.625rem;
  }

  p {
    font-size: 1.125rem;
    margin: auto;
    max-width: 34.375rem;
  }
}

.dashedSquareWithShadow {
  height: 6.25rem;
  margin: 0 auto 1.25rem;
  position: relative;
  width: 6.25rem;

  .shadow {
    border: solid _palette(bg-primary-dark);
    border-radius: 0.625rem;
    border-width: 2.5rem 3.125rem;
    left: 3.125rem;
    position: absolute;
    top: 1.25rem;
    transform: skew(-50deg);
  }

  .dashedSquare {
    border: 0.625rem dashed #999;
    border-radius: 0.625rem;
    height: 6.25rem;
    margin: auto;
    position: absolute;
    width: 6.25rem;
  }
}
